<template>
  <button ref="trigger" type="button" class="tools-trigger" :aria-expanded="opened" aria-label="Open Message Options" title="Message Options" @click="open"><span aria-hidden="true">☰</span></button>
  <template v-if="opened">
    <button type="button" class="tools-backdrop" aria-label="Close Message Options" @click="close" />
    <section class="tools-drawer" aria-label="Message Options" @keydown.esc.stop="close">
      <div class="tools-heading"><strong>Message Options</strong><button ref="closeButton" type="button" @click="close">Close ✕</button></div>
      <div class="tools-sections"><slot /></div>
    </section>
  </template>
</template>
<script>
import { nextTick, ref } from "vue";
export default {
  setup(_, { expose }) {
    const opened = ref(false), trigger = ref(null), closeButton = ref(null);
    const open = async () => { opened.value = true; await nextTick(); closeButton.value?.focus(); };
    const close = () => { opened.value = false; trigger.value?.focus(); };
    expose({ open });
    return { opened, trigger, closeButton, open, close };
  }
};
</script>
<style scoped>
button { border: 0; border-radius: 8px; padding: 8px 12px; background: #edf4ef; color: #24553c; cursor: pointer; }
.tools-trigger { display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; box-sizing: border-box; padding: 0; }
.tools-backdrop { position: absolute; inset: 0; width: 100%; height: 100%; border-radius: 0; background: #17352c33; z-index: 20; }
.tools-drawer { position: absolute; left: 0; top: 0; bottom: 0; width: min(360px, 100%); box-sizing: border-box; padding: 18px; background: white; box-shadow: 5px 0 20px #19372a26; z-index: 21; overflow-y: auto; animation: enter-tools .18s ease-out; }
.tools-sections { display: flex; flex-direction: column; gap: 24px; }
.tools-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 18px; }
@keyframes enter-tools { from { transform: translateX(-100%); } to { transform: translateX(0); } }
@media (prefers-reduced-motion: reduce) { .tools-drawer { animation: none; } }
</style>
